import { Task, TaskActionType } from '@griply/types';

import { normalizeForSearch } from './normalize-for-search';

export const filterTasksBySearchText = (
  tasks: Task[],
  searchText: string,
): Task[] => {
  if (!searchText) {
    return [];
  }
  const normalizedSearchText = normalizeForSearch(searchText.trim());

  return tasks
    .filter(
      ({ name, description, action }) =>
        action?.type !== TaskActionType.GoalTimeslot &&
        action?.type !== TaskActionType.LifeAreaTimeslot &&
        (normalizeForSearch(name).includes(normalizedSearchText) ||
          (!!description &&
            normalizeForSearch(description).includes(normalizedSearchText))),
    )
    .sort(
      (taskA, taskB) =>
        (taskA.completedAt ? 1 : 0) - (taskB.completedAt ? 1 : 0) ||
        new Date(taskA.createdAt).getTime() -
          new Date(taskB.createdAt).getTime(),
    );
};
